import cart from '../helpers/cart';
import log from '../helpers/log';
import miniBasket from './miniBasket';
import currency from '../helpers/currency';
import { facebookAddToCart } from '../helpers/utilities';

interface IConfig {
  form: string,
  quantity: string,
  id: string,
  btn: string,
  btnText: IBtnText,
  price: string
}

interface IBtnText {
  addToBag: string,
  noInventory: string,
  noVariant: string
}

interface IVariant {
  id: number,
  available: boolean,
  options: string[],
  [keyof:string]:any
}

class AddToBag {

  private config:IConfig;

  constructor() {
    this.config = {
      form: '[data-add-to-cart]',
      quantity: '[data-add-to-cart-quantity]',
      id: '[data-add-to-cart-id]',
      btn: '[data-add-to-cart-btn]',
      price: '[data-add-to-cart-price]',
      btnText: {
        addToBag: 'Add To Bag',
        noInventory: 'Out of Stock',
        noVariant: 'Unavailable'
      }
    }
  }

  init() {
    const forms = document.querySelectorAll(this.config.form);
    if (!forms.length) return;
    this.load(forms);
  }

  load(forms:NodeList) {
    forms.forEach((form: HTMLFormElement) => {
      form.addEventListener('submit', this.submit.bind(this, form));
      if (form.dataset.disabled === '') {
        this.enabled(false, {
          id: 0,
          available: false,
          options: null
        });
      }
    });
  }

  quantity(form:HTMLElement) {
    const quantity:HTMLInputElement = form.querySelector(this.config.quantity);
    if (quantity && quantity.value) return parseInt(quantity.value);
    return 1;
  }

  id(form:HTMLElement) {
    const id:HTMLInputElement = form.querySelector(this.config.id);
    if (id && id.value) return parseInt(id.value);
    return;
  }

  enabled(enabled:boolean, variant?:IVariant) {
    document.querySelectorAll(this.config.btn).forEach((btn:HTMLButtonElement) => {
      btn.disabled = !enabled;
      this.updateBtnText(btn, variant);
    });
  }

  updateBtnText(btn:HTMLElement, variant:IVariant) {
    const backInStockBtn = document.querySelector('[data-back-in-stock-open]');
    backInStockBtn.removeEventListener('click', this.openBackInStock);
    backInStockBtn.classList.add('hide');
    if (variant && !variant.available) return this.noInventory(btn);
    if (!variant) return this.noVariant(btn);
    const btnTextNode:HTMLElement = btn.querySelector('.btn-add-to-bag__text');
    btnTextNode.innerText = this.config.btnText.addToBag;
  }

  private noInventory(btn: HTMLElement) {
    const btnTextNode:HTMLElement = btn.querySelector('.btn-add-to-bag__text');
    const backInStockBtn = document.querySelector('[data-back-in-stock-open]');
    btnTextNode.innerText = this.config.btnText.noInventory;
    backInStockBtn.classList.remove('hide');
    backInStockBtn.addEventListener('click', this.openBackInStock);
  }

  private noVariant(btn: HTMLElement) {
    const btnTextNode:HTMLElement = btn.querySelector('.btn-add-to-bag__text');
    btnTextNode.innerText = this.config.btnText.noVariant;
  }

  private openBackInStock() {
    window.BISPopover.show();
  }

  private updateVariant(variant:IVariant) {
    const inputs = document.querySelectorAll(this.config.id);
    const prices = document.querySelectorAll(this.config.price);
    let value:string = null;
    if (variant) value = String(variant.id);
    inputs.forEach((input:HTMLInputElement) => input.value = value);
    prices.forEach((price:HTMLElement) => price.innerText = currency.format(variant.price));
  }

  private enableBtnLoading() {
    document.querySelectorAll(this.config.btn).forEach((btn:HTMLButtonElement) => {
      btn.classList.add('btn-add-to-bag--loading');
    });
  }

  private disableBtnLoading() {
    document.querySelectorAll(this.config.btn).forEach((btn:HTMLButtonElement) => {
      btn.classList.remove('btn-add-to-bag--loading');
    });
  }

  private async submit(form:HTMLElement, event:Event) {
    event.preventDefault();
    this.enableBtnLoading();
    const quantity = this.quantity(form);
    const id = this.id(form);

    if (!id || !quantity) return;

    try {
      facebookAddToCart(await cart.add({
        items: [
          {
            quantity: this.quantity(form),
            id: this.id(form)
          }
        ]
      }));
    }
    catch(error) {
      log.error(error);
    }

    this.disableBtnLoading();
    miniBasket.update();
    miniBasket.open();
  }
}

export default new AddToBag();